<template>
    <div class="logout-container">
        <LogoutModal
            v-if="showCloseConfirm"
            @dismiss="showCloseConfirm = false"
            @close="handlelogout"
        >
            <span slot="header">Se déconnecter</span>
            <span slot="body">Voulez-vous vous déconnecter de l'application ?</span>
        </LogoutModal>
        <div @click="logout" class="action-title logout-link">
            <font-awesome-icon icon="sign-out-alt" class="logout-icon" />
            <div>Se déconnecter</div>
        </div>
    </div>
</template>

<script>
import LogoutModal from './LogoutModal';
import { authenticationService } from '@/services';

export default {
    data() {
        return {
            showCloseConfirm: false,
        };
    },
    methods: {
        logout() {
            this.showCloseConfirm = true;
        },
        handlelogout() {
            authenticationService.logout();
            this.$router.push('/login');
        },
    },
    components: {
        LogoutModal,
    },
};
</script>

<style lang="scss">
.logout-container {
    padding: 0px !important;
    display: initial !important;
}
.logout-link {
    background: #6c3e91;
    > div {
        color: #fff !important;
    }
    .logout-icon {
        color: #fff;
        font-size: 16px;
        line-height: 16px;
        width: 14px;
        height: 16px;
        padding-right: 14px;
    }
}
</style>
